import { render, staticRenderFns } from "./plenigo-auth.vue?vue&type=template&id=44c49d9a&"
import script from "./plenigo-auth.vue?vue&type=script&lang=js&"
export * from "./plenigo-auth.vue?vue&type=script&lang=js&"
import style0 from "./plenigo-auth.vue?vue&type=style&index=0&id=44c49d9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports